import { defineStore } from 'pinia';
import { apiBase, apiFetch } from '@/composables/useApi';
import type { AuthUser } from '@/types';

type Status = 'idle' | 'loading' | 'authenticated' | 'anonymous';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    status: 'idle' as Status,
    user: null as AuthUser | null,
    error: null as string | null,
  }),

  getters: {
    isAuthenticated: (state) => state.status === 'authenticated' && state.user !== null,
  },

  actions: {
    async fetchMe() {
      this.status = 'loading';
      this.error = null;
      try {
        const data = await apiFetch<AuthUser>('/auth/me');
        this.user = data;
        this.status = 'authenticated';
      } catch (err) {
        this.user = null;
        this.status = 'anonymous';
        if (err && typeof err === 'object' && 'status' in err) {
          const e = err as unknown as { status: number; message?: string };
          if (e.status !== 401) {
            this.error = e.message ?? 'Unbekannter Fehler';
          }
        }
      }
    },

    loginWithDiscord() {
      window.location.href = `${apiBase()}/auth/discord`;
    },

    async logout() {
      try {
        await apiFetch('/auth/logout', { method: 'POST' });
      } finally {
        this.user = null;
        this.status = 'anonymous';
      }
    },
  },
});
